import { useEffect } from "react";
import { Button, Flex, HStack, VStack, Text, Box, Heading } from "@chakra-ui/react";
import { useUser } from "providers/UserProvider";
import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { AuthService } from "services/authService";
import { useTranslation } from "react-i18next";

const Callback = () => {
  const invalidCredentialsErrorMessage = "Inloggningen misslyckades";
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const { setUser } = useUser();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setAuthError(false);

    const runAuth = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");

        const message = params.get("message");
        if (message) {
          setError(message);
          setAuthError(true);
          return;
        }

        if (!token) {
          console.error("No token found in the URL");
          setAuthError(true);
          return;
        }

        const tokens = await AuthService.loginWithCustomToken({
          customToken: token,
        });

        if (!tokens) {
          console.error("No tokens returned.");
          throw new Error("No token returned.");
        }

        if (!AuthService.isAppUser(tokens.access_token)) {
          console.error("User is not a Myran user.");
          setError("User is not a Myran user.");
          // throw new Error('User is not a Myran user.');
          return;
        }

        AuthService.clearCookie();
        AuthService.storeTokens(tokens);
        const usr = AuthService.getUser();
        if (usr) {
          setUser(usr);
          setAuthError(false);
        }

        history.replace("/");
      } catch (error) {
        setAuthError(true);
      } finally {
        setIsLoading(false);
      }
    };

    runAuth();
  }, [location, history, setUser]);

  return (
    <Flex
      w="100vw"
      h="100vh"
      justifyContent="center"
      alignItems="center"
      // spacing='12'
    >
      <Box
        borderRadius="5%"
        bgColor="darkIndigo"
        borderColor="rgba(255, 255, 255, .3)"
        borderWidth="1px"
        pos="absolute"
        zIndex="0"
        h="420px"
        w="460px"
        top="50%" // Move to 50% from top
        left="50%" // Move to 50% from left
        transform="translate(-50%, -50%)" // Centering trick
        // spacing='12'
      >
        <VStack w="full" alignItems="stretch">
          <Heading
            as="h1"
            fontSize="22"
            fontWeight="semibold"
            lineHeight="1.6"
            mt={10}
            mb={5}
            alignSelf="center"
            color="white"
          >
            {t("Login_SSO_Title")}
          </Heading>
          <VStack ml="5" w="full" justifyContent="center" paddingTop="10px">
            {authError && (
              <VStack w="full" justifyContent="center" alignContent="center" pt="4" mb="20" alignItems="center">
                <Text fontWeight="light" color="white">
                  {invalidCredentialsErrorMessage}
                </Text>
                <Text fontWeight="light" color="white" textAlign="center">
                  {error}
                </Text>
              </VStack>
            )}
            <Button
              height={10}
              w="342px"
              fontSize={14}
              variant={"solid"}
              type="button"
              onClick={() => history.push("/login")}
              // rightIcon={<ArrowForwardIcon boxSize='6' />}
              isLoading={isLoading}
              backgroundColor={"#ff5099"}
              _hover={{ bg: "#EF3A86" }}
            >
              {t("Back_Text")}
            </Button>
          </VStack>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Callback;
